<template>
    <NuxtLink
        :to="pdf.file"
        target="_blank"
        class="duration-200 hover:scale-105"
    >
        <UCard class="h-full bg-black/10">
            <template #header>
                <div class="flex justify-center bg-white p-2 shadow-md">
                    <NuxtPicture
                        :src="pdf.image"
                        :alt="pdf.title"
                        class="w-1/3"
                    />
</div>
            </template>
            <template #default>
              <h3 class="h4">
                    {{ pdf.title }}
                </h3>
                <p>{{ pdf.type }} | {{ pdf.size }}</p>
              <UButton block icon="i-lucide-download" label="Herunterladen"/>
            </template>
        </UCard>
    </NuxtLink>
</template>

<script setup lang="ts">

const {pdf} = defineProps({pdf: {}});
</script>

<style scoped>

</style>
